<template>
  <div>
    <page-header :title="this.title || $t('bill.text_247')">
      <div slot="res-status-tab" style="position: absolute; right: 0; top: 10px;">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <!-- 多维度分析报告 -->
      <div class="d-flex align-items-center justify-content-between mb-3">
        <fixed-label-filter :label="$t('common.template')">
          <base-select
            ref="reportSelect"
            v-model="reportId"
            isDefaultSelect
            resource="bill_analysis_reports"
            :params="reportParams"
            :select-props="{placeholder: $t('common.tips.select', [$t('bill.analysis_report').toLowerCase()])}"
            @update:item="reportChange"
            @update:resList="reportListLoaded"
            @update:initLoaded="initReportLoaded"
            @update:initError="initReportLoaded" />
        </fixed-label-filter>
        <div>
          <a-button type="primary" ghost @click="saveReport">{{saveButtonText}}</a-button>
          <a-button class="ml-2" type="primary" ghost @click="setAlarm">{{$t('bill.set_alarm')}}</a-button>
        </div>
      </div>
      <analysis ref="analysis" :billShared="billShared" :projectShared="projectShared" :reportId="reportId" :reportLoaded="reportLoaded" @refreshReport="refreshReport" />
    </page-body>
  </div>
</template>

<script>
import BillConfig from '@Bill/sections/BillConfig'
import shareMixin from '@Bill/mixins/share'
import WindowsMixin from '@/mixins/windows'
import Analysis from './component/index'

export default {
  name: 'BillAnalysis',
  components: {
    Analysis,
    BillConfig,
  },
  mixins: [shareMixin, WindowsMixin],
  props: {
    title: String,
  },
  data () {
    const { reportData = {} } = this.$route.params
    return {
      reportId: reportData.id || undefined,
      reportParams: {
        scope: this.$store.getters.scope,
        limit: 20,
      },
      reportLoaded: false,
    }
  },
  computed: {
    saveButtonText () {
      return this.reportId ? this.$t('bill.save_as_report1') : this.$t('bill.save_as_report')
    },
  },
  mounted () {
    this.initReportData()
  },
  methods: {
    initReportLoaded () {
      this.reportLoaded = true
    },
    initReportData () {
      const { reportData, formData } = this.$route.params
      if (reportData && formData) {
        this.reportLoaded = true
        this.$refs.analysis.setFormTemplateData(formData)
      }
    },
    setAlarm () {
      const params = this.$refs.analysis.genParams()
      if (params.group) {
        params.group = params.group.filter(item => item !== 'aggregate_usage_unit')
      }
      if (params.groups) {
        params.groups = params.groups.filter(item => item.group !== 'aggregate_usage_unit')
      }
      this.$router.push({
        name: 'BillAnalysisAlarmCreate',
        params: {
          data: {
            ...params,
            query_type: 'expense_trend',
            bill_type: this.$refs.analysis.formData.bill_type,
            groups: (this.$refs.analysis.formData.groups || []).filter(item => item.group !== 'aggregate_usage_unit'),
          },
        },
      })
    },
    reportChange (data) {
      this.reportLoaded = true
      const { formData = {} } = data.query_attributes
      const { date_mode, start_date, end_date } = formData.date || {}
      this.$refs.analysis.$refs.dataTime.time.dateMode = date_mode
      if (date_mode === 'custom' && start_date) {
        this.$refs.analysis.$refs.dataTime.time.date = [this.$moment(start_date.replace('TZ', '')), this.$moment(end_date.replace('TZ', ''))]
        this.$refs.analysis.$refs.dataTime.customDate.start = this.$moment(start_date.replace('TZ', ''))
        this.$refs.analysis.$refs.dataTime.customDate.end = this.$moment(end_date.replace('TZ', ''))
      }
      this.$refs.analysis.$refs.dataTime.handleDateModeChange()
      this.$refs.analysis.setFormTemplateData(formData)
      this.$nextTick(() => {
        ['tag_key', 'tag_key1', 'project_tag_key', 'project_tag_key1'].map(field => {
          if (formData[field]) {
            this.$refs.analysis.form.setFieldsValue({ [field]: formData[field] })
          }
        })
      })
    },
    saveReport () {
      this.createDialog('AnalysisSaveReportDialog', {
        action: this.saveButtonText,
        formData: this.$refs.analysis.genReportData(),
        refresh: (data) => {
          this.reportId = data.id
          this.refreshReport(data)
        },
      })
    },
    refreshReport () {
      this.$refs.reportSelect.refresh()
    },
    reportListLoaded (list) {
      this.reportListLoaded = true
      if (!list.length) {
        this.$nextTick(() => {
          this.$refs.analysis.fetchData()
        })
      }
    },
  },
}
</script>
